import useSWR from 'swr';
import axiosInstance from '@/lib/axios';
import type { Member } from '@/types';

const fetcher = (url: string) => axiosInstance.get(url).then((res) => res.data);

interface CommunityMembersData {
  members: Member[];
  currentUserId?: string;
  metadata: {
    totalCount: number;
    totalPages: number;
    currentPage: number;
    limit: number;
  };
}

export function useCommunityMembers(
  communityId?: string,
  options: { page?: number; limit?: number; search?: string } = {}
) {
  const { page = 1, limit = 100, search = '' } = options;

  const { data, error, isLoading, mutate } = useSWR<CommunityMembersData>(
    communityId
      ? `/api/communities/${communityId}/members?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`
      : null,
    fetcher
  );

  return {
    members: data?.members || [],
    currentUserId: data?.currentUserId,
    metadata: data?.metadata,
    isLoading,
    isError: error,
    mutate,
  };
}
